import { createFileRoute } from '@tanstack/react-router'

import { Login } from '~/boundedContext/auth/pages/login'

export const Route = createFileRoute('/auth/login')({
  component: Login,
})
